// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__BIN7F","buttons":"Footer_buttons__3ejvv"};